import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CustomCalendarRange = ({
    isClearable = false,
    className = "",
    holder = "Selecciona rango de fechas",
    valueStart = null,
    valueEnd = null,
    filters,
    setFilters,
}) => {
    const [dateRange, setDateRange] = useState([valueStart, valueEnd]);
    const [startDate, endDate] = dateRange;

    const onChange = (update) => {
        setDateRange(update);

        // Actualiza los filtros externos
        if (setFilters && typeof setFilters === "function") {
            setFilters({ ...filters, start_date: update[0], end_date: update[1], })
        }
    };

    return (
        <DatePicker
            selectsRange
            startDate={startDate}
            endDate={endDate}
            onChange={onChange}
            isClearable={isClearable}
            placeholderText={holder}
            className={`w-full border border-gray-300 mt-1 rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-fr-primary focus:border-fr-primary ${className}`}
            dateFormat="yyyy/MM/dd"
            
            popperClassName="z-[9999]" // 👈 z-index alto
        />
    );
};

export default CustomCalendarRange;
